export default "__VITE_ASSET__BlWoqt2q__"